import useDragAndDrop from '../../Components/DragAndDrop/Hooks/useDragAndDropHook';
import IndicatorsManagementButton from '../../Components/Form/Buttons/IndicatorsManagementButton/IndicatorsManagementButton';
import useLanguage from '../../Services/Language/useLanguageHook';
import styles from './DragAndDropWrapper.module.scss';

interface IAddWidgetCustomizationProps {
    handleAddWidgetClick: (rowOrder: number, widgetOrder: number) => void;
    addWidgetRowOrder: number;
    addWidgetWidgetOrder: number;
    widgetId: string;
}

const AddWidgetCustomization: React.FC<IAddWidgetCustomizationProps> = (props: IAddWidgetCustomizationProps) => {
    const [translations] = useLanguage();
    const { dragProps } = useDragAndDrop(props.widgetId, true);

    const handleIconClick = () => {
        props.handleAddWidgetClick(props.addWidgetRowOrder, props.addWidgetWidgetOrder);
    };

    return (
        <div ref={dragProps.reference} className={styles.dragAndDrop_add_new_widget_container}>
            <IndicatorsManagementButton
                handleClick={handleIconClick}
                tooltipText={translations.dashboardCustomization.tooltips.addNewWidget}
                track={{ eventCategory: 'Dashboard', eventAction: 'AddNewWidgetClicked' }}
            />
        </div>
    );
};

export default AddWidgetCustomization;
